import React from "react";
import { Button } from "reactstrap";
import cardBlogs from "../../../data/cardBlogs.json";
import "./style.css";

function CardBlogs() {
  return (
    <div className="pt-5">
      <div className="row">
        {cardBlogs.cardBlogs.map((item, index) => (
          <div className="col-4 px-4 pb-5" key={index}>
            <div className="blogs_img">
              <img src={item.img} alt="img" width="100%" />
            </div>

            <div className="text-center">
                <p className="mt-4 fs-5 fw-bold blog_name px-5">{item.name}</p>

                <div className="mb-3 fs-13 pt-2">
                    <span className="t-grey">{item.date}</span>
                    <span className="t-grey">|</span>
                    <span className="t-grey">{item.comment}</span>
                    <span className="t-grey">|</span>
                    <span className="t-grey">{item.view}</span>
                    <span className="t-grey">|</span>
                    <span className="t-grey">{item.theme}</span>
                </div>

                <p className="t-grey blog_text px-2">{item.text}</p>

                <Button className="mt-4 btn_custom rounded-0">Read More</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CardBlogs;
